// Simple Design Tokens Utility
export const expansionColors: Record<string, string> = {
  'Core': 'var(--color-accent-core-tyria)',
  'S1': 'var(--color-accent-core-tyria)',
  'S2': 'var(--color-accent-living-s2)',
  'HoT': 'var(--color-accent-hot)',
  'S3': 'var(--color-accent-living-s3)',
  'PoF': 'var(--color-accent-pof)',
  'S4': 'var(--color-accent-living-s4)',
  'Icebrood': 'var(--color-accent-icebrood)',
  'EoD': 'var(--color-accent-eod)',
  'SotO': 'var(--color-accent-obscure)',
  'Janthir': 'var(--color-accent-janthir)',
  'VoE': 'var(--color-accent-VoE)',
};

export const tokens = {
  color: {
    bg: 'var(--color-bg-primary)',
    bgAbsolute: 'var(--color-bg-absolute)',
    text: 'var(--color-text-default)',
    textMuted: 'var(--color-text-default)',
    bgCompleted: 'var(--color-accent-living-s3)',
  },
  font: {
    newsreaderH1: 'var(--typography-newsreader-h1-medium)',
    inconsolataH2: 'var(--font-inconsolata-h2)',
    inconsolataBody: 'var(--font-inconsolata-body)',
  },
  space: (size: string) => `var(--spacing-${size})`,
  radius: (size: string) => `var(--radius-${size})`,
  shadow: (type: string) => `var(--shadow-${type})`,
};